import { comparePostsByDate } from '../../utils/posts';

/* eslint-disable import/prefer-default-export */
export const fetchClassRoomScheduledPostsReducer = (state, action) => {
  switch (action.status) {
    case 'success': {
      const { scheduledPosts } = action;
      const ids = [];
      const posts = { ...state.posts };
      scheduledPosts.forEach((post) => {
        ids.push(post.objectId);

        if (!posts[post.objectId]) {
          posts[post.objectId] = {
            ...post,
            comments: [],
            tags: [],
          };
        }
      });

      const classRooms = { ...state.classRooms };
      if (scheduledPosts.length > 0) {
        const classRoomId = scheduledPosts[0].classRoom;
        const classRoom = classRooms[classRoomId];
        const order = 1;
        const classRoomScheduledPosts = [
          ...new Set([...classRoom.scheduledPosts, ...ids]),
        ]
          .map((id) => posts[id])
          .sort(comparePostsByDate(order))
          .map((p) => p.objectId);

        classRooms[classRoomId] = {
          ...classRoom,
          scheduledPosts: classRoomScheduledPosts,
        };
      }

      return {
        ...state,
        posts,
        classRooms,
      };
    }
    case 'error':
      return {
        ...state,
      };

    default:
      return state;
  }
};
